import { createSelector } from '@reduxjs/toolkit'

import { AccountType, Permission } from '@app/models'

import { UserState } from './types'

export const hasPermission = createSelector(
  (state: UserState) => state.permissions || [],
  (permissions: Permission[]) => {
    return (permission: string) =>
      permissions.filter(
        (p) => p.permission === permission && p.value == 'Allow'
      ).length > 0
  }
)

export const hasRole = createSelector(
  (state: UserState) => state.currentUser.accountsRoles || [],
  (state: UserState) => state.account?.id,
  (accountsRoles, accountId) => {
    return (role: string) =>
      accountsRoles.some(
        (accountRole) =>
          accountRole.accountId === accountId && accountRole.role === role
      )
  }
)

export const hasAccountType = createSelector(
  (state: UserState) => state.account?.type,
  (accountType) => {
    return (type: AccountType) => accountType === type
  }
)

export const isInvited = createSelector(
  (state: UserState) => state.currentUser?.status,
  (status: string) => {
    return status === 'Invited'
  }
)
